import gsap from 'gsap';

export function useScrollAnimations() {
  const slideUp = (element, delay = 0, duration = 1.4) => {
    if (!element) return;
    gsap.fromTo(
      element,
      { y: 50, opacity: 0, willChange: 'transform, opacity' },
      {
        y: 0, opacity: 1, duration, delay, ease: 'power3.out',
        onComplete: () => {
          gsap.set(element, { willChange: 'auto' });
        }
      },
    );
  };

  const slideLeft = (element, delay = 0, duration = 1) => {
    if (!element) return;
    gsap.fromTo(
      element,
      { x: -50, opacity: 0, willChange: 'transform, opacity' },
      {
        x: 0, opacity: 1, duration, delay, ease: 'power3.out',
        onComplete: () => {
          gsap.set(element, { willChange: 'auto' });
        }
      },
    );
  };

  const slideRight = (element, delay = 0, duration = 1) => {
    if (!element) return;
    gsap.fromTo(
      element,
      { x: 50, opacity: 0, willChange: 'transform, opacity' },
      {
        x: 0, opacity: 1, duration, delay, ease: 'power3.out',
        onComplete: () => {
          gsap.set(element, { willChange: 'auto' });
        }
      },
    );
  };

  const countUp = (refValue, targetValue, duration = 2) => {
    gsap.to(refValue, {
      value: targetValue,
      duration,
      ease: 'power2.out',
    });
  };

  const animateInView = (triggerElement, callback, threshold = 0.2) => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback();
          observer.unobserve(entry.target);
        }
      });
    }, { threshold });

    if (triggerElement) observer.observe(triggerElement);
  };

  return {
    slideUp,
    slideLeft,
    slideRight,
    countUp,
    animateInView,
  };
}
